import React, { useContext, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { UserContext } from '../../context/UserContext';
import { sessionIsAdmin } from '../../utils/adminAuth';
import { useMessages } from './MessagesContext';
import ConversationList from './ConversationList';
import ConversationThread from './ConversationThread';
import './MessagesDrawer.css';

const MessagesDrawer = () => {
    const { user } = useContext(UserContext);
    const {
        isOpen,
        closeMessages,
        conversations,
        loading,
        activeConversationId,
        draftConversation,
        setActiveConversationId,
        clearDraftConversation,
    } = useMessages();

    useEffect(() => {
        if (!isOpen) return undefined;
        const onKeyDown = (event) => {
            if (event.key === 'Escape') closeMessages();
        };
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, closeMessages]);

    if (sessionIsAdmin(user) || !isOpen) return null;

    const activeConversation = conversations.find(
        (conversation) => Number(conversation.conversationId) === Number(activeConversationId)
    );
    const showingThread = Boolean(activeConversationId) || Boolean(draftConversation);

    const handleBackToList = () => {
        if (draftConversation) {
            clearDraftConversation();
        }
        setActiveConversationId(null);
    };

    return (
        <div className="messages-drawer-root">
            <button type="button" className="messages-drawer-backdrop" aria-label="Close messages" onClick={closeMessages} />
            <aside className="messages-drawer-panel" aria-label="Messages">
                <header className="messages-drawer-header">
                    {showingThread ? (
                        <button
                            type="button"
                            className="messages-drawer-back"
                            onClick={handleBackToList}
                        >
                            ← Chats
                        </button>
                    ) : (
                        <h2>Messages</h2>
                    )}
                    <div className="messages-drawer-header-actions">
                        <button type="button" className="messages-drawer-close" onClick={closeMessages} aria-label="Close messages">
                            <FiX />
                        </button>
                    </div>
                </header>
                <div className="messages-drawer-body">
                    {activeConversationId ? (
                        <ConversationThread
                            conversationId={activeConversationId}
                            initialConversation={activeConversation}
                            variant="drawer"
                        />
                    ) : draftConversation ? (
                        <ConversationThread
                            draft={draftConversation}
                            variant="drawer"
                        />
                    ) : (
                        <ConversationList
                            conversations={conversations}
                            loading={loading}
                            onSelect={(conversation) => setActiveConversationId(conversation.conversationId)}
                            selectedConversationId={activeConversationId}
                        />
                    )}
                </div>
            </aside>
        </div>
    );
};

export default MessagesDrawer;
